const reasons = [
  {
    icon: 'ri-eye-line',
    number: '01',
    title: 'Скорость и Глубина',
    text: 'Благодаря ИИ-агентам мы видим закономерности рынка, которые пропускает человеческий глаз. Анализ конкурентов — за часы, не за недели.',
  },
  {
    icon: 'ri-focus-3-line',
    number: '02',
    title: 'Экономическая логика',
    text: 'Мы не тратим время на «лайки» — мы следим за тем, чтобы контент решал бизнес-задачи (JTBD). Каждое действие привязано к показателям продаж.',
  },
  {
    icon: 'ri-money-cny-circle-line',
    number: '03',
    title: 'Оптимизация бюджета',
    text: 'Один стратег, усиленный ИИ, заменяет целый отдел маркетинга — сохраняя ваши деньги и обеспечивая премиальное качество на каждом этапе.',
  },
];

export default function SMMWhyChooseUs() {
  return (
    <section className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-shield-star-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Наши преимущества
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Почему предприниматели выбирают<br className="hidden sm:block" /> наш подход?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-8">
          {reasons.map((r) => (
            <div key={r.number} className="relative bg-[#F9F5EF] rounded-2xl p-6 sm:p-8 border border-[#E8DDD0] hover:border-[#C5A880] transition-colors duration-300">
              <div className="absolute top-5 right-6 text-5xl font-extrabold text-[#1A2B4C]/05 font-['Playfair_Display'] select-none">
                {r.number}
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#1A2B4C] mb-5">
                <i className={`${r.icon} text-2xl text-[#C5A880]`}></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3 leading-snug">
                {r.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] text-justify">
                {r.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
